module.exports = __webpack_public_path__ + "img/pay2.5694404a.png";